/**
 * The shell's TOP BAR (#2502 §5.1; the portal design's `header.top`), as SLOTS.
 *
 * Left to right: an optional LEAD (the compact navigation toggle), the CRUMB
 * (`Crumb`, the one elastic child), the SEARCH slot (`SlotTrigger`), the
 * ACCOUNT SWITCHER (only for a caller holding more than one account — absent
 * in the design, and never lost), NOTIFICATIONS, a joint, the ACCOUNT trigger,
 * and an optional TRAIL (the OnMarble launcher). Every slot is a node the host
 * already rendered; an absent slot draws nothing and leaves no gap, and the
 * joint is drawn only when there is something on both sides of it.
 *
 * It fetches nothing and knows no host: which crumb, which menu and what the
 * notifications button opens are the host's. The console's `Topbar.tsx` still
 * draws its own bar; adopting this piece there is a recorded hand-off (#2502).
 */
import type { ReactNode } from 'react'
import { cx } from '../controls/cx'
import s from './TopBar.module.css'

export interface TopBarProps {
  lead?: ReactNode
  crumb?: ReactNode
  search?: ReactNode
  accountSwitcher?: ReactNode
  notifications?: ReactNode
  account?: ReactNode
  trail?: ReactNode
  className?: string
  testId?: string
}

export function TopBar({
  lead, crumb, search, accountSwitcher, notifications, account, trail, className, testId = 'top-bar',
}: TopBarProps) {
  const joint = notifications != null && account != null
  return (
    <header className={cx(s.bar, className)} data-testid={testId}>
      {lead}
      {/* The crumb is the elastic child; with none, a spacer keeps the
          controls at the end of the row. */}
      {crumb ?? <span className={s.spacer} aria-hidden />}
      {search}
      {accountSwitcher}
      {notifications}
      {joint && <span className={s.joint} aria-hidden data-testid="top-bar-joint" />}
      {account}
      {trail}
    </header>
  )
}
